var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5003 9.66668H4.83366C4.19272 9.66668 3.57803 9.92129 3.12482 10.3745C2.6716 10.8277 2.41699 11.4424 2.41699 12.0833V16.9167C2.41699 17.5576 2.6716 18.1723 3.12482 18.6255C3.57803 19.0787 4.19272 19.3333 4.83366 19.3333H6.04199V24.1667C6.04199 24.4871 6.1693 24.7945 6.39591 25.0211C6.62251 25.2477 6.92986 25.375 7.25033 25.375H9.66699C9.98746 25.375 10.2948 25.2477 10.5214 25.0211C10.748 24.7945 10.8753 24.4871 10.8753 24.1667V19.3333H14.5003L20.542 24.1667V4.83334L14.5003 9.66668ZM25.9795 14.5C25.9795 16.5663 24.8195 18.4392 22.9587 19.3333V9.66668C24.8074 10.5729 25.9795 12.4458 25.9795 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTts);
export default __webpack_public_path__ + "static/media/tts.a4318caee1d32f6990f63137e1ecef9d.svg";
export { ForwardRef as ReactComponent };